'use client'

import { useAppDispatch, useAppSelector } from '@/lib/store'
import { setDrawerOpen } from '@/lib/store/features/booking/bookingSlice'
import { Drawer } from '@heroui/react'
import ReservationDrawerPanel from '../layout/ReservationDrawer'

export function ReservationDrawerWrapper() {
  const dispatch = useAppDispatch()
  const isOpen = useAppSelector((state) => state.booking.current.isDrawerOpen)

  const handleClose = () => dispatch(setDrawerOpen(false))

  return (
    <Drawer.Backdrop isOpen={isOpen} onOpenChange={(open) => dispatch(setDrawerOpen(open))}>
      <Drawer.Content placement='right'>
        <Drawer.Dialog>
          <Drawer.CloseTrigger />
          <Drawer.Header>
            <Drawer.Heading>Your Reservation</Drawer.Heading>
          </Drawer.Header>
          <Drawer.Body>
            <ReservationDrawerPanel onClose={handleClose} />
          </Drawer.Body>
        </Drawer.Dialog>
      </Drawer.Content>
    </Drawer.Backdrop>
  )
}
